export const PRIVATE_ROUTE = 'PRIVATE_ROUTE';
export const PUBLIC_ROUTE = 'PUBLIC_ROUTE';
export const ADMIN_ROUTE = 'ADMIN_ROUTE';
export const ORGANIZATION_ROUTE = 'ORGANIZATION_ROUTE';

export const PRIVATE_DEFAULT_ROUTE = '/home';
export const PUBLIC_DEFAULT_ROUTE = '/login';
export const SETTINGS_ROUTE = '/settings';
export const LOGIN_ROUTE = '/login';
export const ORGANIZATION_PAGE_ROUTE = '/organization';
export const MANAGE_PROFILE = '/manage-profile';

export const ERROR_IMAGES = {
  ERROR_404: { message: 'The requested page does not exist.', image: '/img/404_error.svg' },
  ERROR_500: { message: 'Something went wrong', image: '/img/500_error.svg' },
  ERROR_403: { message: 'You are not authorized to access this page', image: '/img/500_error.svg' },
};
export const REFRESH_TOKEN = 'refresh_token';
export const AUTHENTICATION_TOKEN = 'authenticationToken';
export const ORGANIZATION_COOKIE = 'organization';
export const DELETE_MODAL = 'DELETE';
export const RENAME_MODAL = 'RENAME';
export const UPLOAD_MODAL = 'UPLOAD';
export const RENAME_FILE_MODAL = 'RENAME_FILE';
export const FILE_SETTINGS_MODAL = 'FILE_SETTINGS';
export const CREATE_ANNOUNCEMENT_MODAL = 'CREATE_ANNOUNCEMENT_MODAL';
export const SAVE_AS_TEMPLATE_MODAL = 'SAVE_AS_TEMPLATE_MODAL';
export const WORKSPACE_SETTINGS_MODAL = 'WORKSPACE_SETTINGS';
export const WORKSPACE_IMPORT_MODAL = 'WORKSPACE_IMPORT';
export const WORKSPACE_CATEGORY_CHANGE_MODAL = 'WORKSPACE_CATEGORY_CHANGE';
export const OPEN_API_POPOVER_OPTIONS = ['delete', 'rename'];
export const OPEN_SHARE_MODAL = 'OPEN_SHARE_MODAL';
export const TEMPLATE_SUCCESS_MODAL = 'TEMPLATE_SUCCESS_MODAL';

export const colorsCollection = [
  '#1677ff',
  '#fa541c',
  '#13c2c2',
  '#722ed1',
  '#eb2f96',
  '#2f54eb',
  '#52c41a',
  '#fa8c16',
  '#1890ff',
  '#ff4d4f',
  '#5cdbd3',
  '#b37feb',
  '#ff85c0',
  '#597ef7',
  '#73d13d',
  '#ffc53d',
  '#40a9ff',
  '#ff7875',
  '#36cfc9',
  '#9254de',
  '#ffadd2',
  '#85a5ff',
  '#b7eb8f',
  '#ffd666',
  '#69c0ff',
  '#ffccc7',
];

export const DOCUMENTS_TYPE = {
  RECENTLY_EDIT: 'recently edit',
  STARRED: 'starred',
  SHARED: 'shared',
  OWNED: 'owned',
  TEMPLATES: 'templates',
};

export const WORKSPACE_TYPE = [
  { label: 'ALL', value: 'all' },
  { label: 'Service', value: 'SERVICE' },
  { label: 'Team', value: 'TEAM' },
  { label: 'Project', value: 'PROJECT' },
  { label: 'Others', value: 'OTHERS' },
];

export const Released_Announcement_Steps = ['Select platform', 'Summaries document', 'Preview and share'];
